import { Chip } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"

import { CustomerProductFileRowActions } from "./CustomerProductFileRowActions"

import FileChip from "@/components/upload/components/display/FileChip"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { CUSTOMER_PRODUCT_FILE_TYPE_MAPPING } from "@/screens/CustomerProducts/constants"
import type { CustomerProductFileType } from "@/screens/CustomerProducts/types"

const fileTypeChipContent = (fileFieldGroup: CustomerProductFileType) => {
  const chipInfo = CUSTOMER_PRODUCT_FILE_TYPE_MAPPING[fileFieldGroup]
  return <Chip className='mr-2 rounded-full' sx={{ backgroundColor: chipInfo?.color }} label={chipInfo?.label ?? ""} />
}

export const useCustomerProductFilesColumns = (
  onRemove: (fileId: string) => Promise<boolean>
): ColumnDef<SignedUrl>[] => {
  return [
    {
      accessorKey: "fileType",
      header: "Type",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 100,
      cell: ({ row }) => fileTypeChipContent(row.original.file?.fieldGroup as CustomerProductFileType),
    },
    {
      accessorKey: "file",
      header: "File",
      size: 150,
      enableSorting: false,
      cell: ({ row }) => <FileChip file={row.original} showExtension />,
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 300,
      enableSorting: false,
      cell: ({ row }) => row.original.file?.label || "",
    },
    {
      accessorKey: "actions",
      header: "",
      enableSorting: false,
      size: 72,
      cell: ({ row }) => <CustomerProductFileRowActions row={row} onRemove={onRemove} />,
    },
  ]
}
